/* eslint-disable jsx-a11y/img-redundant-alt */
import parse, { domToReact } from 'html-react-parser';
import { isEmpty, renderPrntImageFile, serializeNode } from '../../helpers/common';
import RenderVideoFile from '../renderVideoFile';
import { RenderImagePreview } from '../renderImagePreview';
import { ActionDiv } from './styles';
import { Dropdown, DropdownItem } from '../dropdown';
import copy from 'clipboard-copy';
import TiptapEditor from '../tiptapEditor';
import escape from 'lodash/escape';
import { BUTTON_TYPE, ICON_BUTTON_SIZE, ICON_BUTTON_TYPE, IMAGE_TYPE } from '../../global/constants';
import { dispatchTaskSuccess } from '../../services/taskServices';
import TaskLinkEmbedCard from '../taskLinkEmbed';
import ProjectEmbedCard from '../projectEmbedCard';
import FigmaEmbedCard from '../figmaEmbedCard';
import { useMobileDevice } from '../../global/useMobile';
import { useHistory } from 'react-router-dom';
import Button from '../button';
import IconButton from '../button/iconButton';

interface CodeChildNode {
  data?: string;
}

function RenderHtml({
  htmlString,
  isReplyText,
  figmaLoading,
  onClickRefreshFigma
}: {
  htmlString: string;
  isReplyText?: boolean;
  figmaLoading?: boolean;
  onClickRefreshFigma?: (figmaURL: string) => void;
}) {
  const mobile = useMobileDevice();
  const history = useHistory();

  const isSameDomain = (url: string) => {
    try {
      const currentDomain = window.location.hostname;
      const urlDomain = new URL(url).hostname;
      return currentDomain === urlDomain;
    } catch (error) {
      return false;
    }
  };

  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (isSameDomain(href)) {
      e.preventDefault();
      const url = new URL(href);
      history.push(url.pathname + url.search + url.hash);
    }
  };
  return (
    <>
      {parse(`<div>${htmlString}</div>`, {
        // Can't define type for domNode
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        replace: (domNode: any) => {
          // Handle image upload embed spans
          if (
            domNode.type === 'tag' &&
            domNode.name === 'div' &&
            domNode.attribs?.['data-type'] === 'image-upload-embed' &&
            domNode.attribs?.['src']
          ) {
            return (
              <RenderImagePreview
                imageUrl={domNode.attribs['src']}
                altText='Uploaded image'
                isImage={true}
                ShowImageOptions={true}
                type='Image'
              />
            );
          }
          if (
            domNode.type === 'tag' &&
            domNode?.attribs?.class?.includes('figma-main-div') &&
            !isEmpty(domNode.attribs.filepreviewurl)
          ) {
            return (
              <FigmaEmbedCard
                node={domNode}
                frameNames={domNode.attribs?.framenames}
                projectName={domNode.attribs?.framenames}
                filePreviewUrl={domNode.attribs?.filepreviewurl}
                url={domNode.attribs?.url}
                isLoading={domNode.attribs?.isloading === 'true'}
                figmaLoading={figmaLoading}
                onClickRefreshFigma={onClickRefreshFigma}
              />
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('figma-right-div')) {
            const onClickCopyFigmaLink = async (url: string) => {
              await copy(url);
              dispatchTaskSuccess('Figma url copied successfully!');
            };
            return (
              <ActionDiv className='figma-right-div'>
                {!mobile && (
                  <IconButton
                    iconName='repeat-icon'
                    size={ICON_BUTTON_SIZE.MEDIUM}
                    variant={ICON_BUTTON_TYPE.TERTIARY}
                    className={`refresh-icon ${figmaLoading ? 'refresh-icon-spin' : ''}`}
                    id='figma-refresh-ref'
                  />
                )}
                <Button
                  onClick={() => window.open(domNode.children?.[1]?.attribs?.href, '_blank')}
                  title='Open in Figma'
                  size='small'
                  variant={BUTTON_TYPE.SECONDARY}
                />
                <div className='three-dot-icon'>
                  {mobile && (
                    <IconButton
                      iconName='repeat-icon'
                      size={ICON_BUTTON_SIZE.MEDIUM}
                      variant={ICON_BUTTON_TYPE.TERTIARY}
                      className={`refresh-icon ${figmaLoading ? 'refresh-icon-spin' : ''}`}
                      id='figma-refresh-ref'
                    />
                  )}
                  <div className='three-dot-icon'>
                    <Dropdown
                      modalTitle='Share'
                      isMinWidth={150}
                      activeClassName='active'
                      content={
                        <IconButton
                          iconName='new-three-dots-vertical-icon'
                          size={ICON_BUTTON_SIZE.MEDIUM}
                          variant={ICON_BUTTON_TYPE.TERTIARY}
                        />
                      }>
                      <DropdownItem
                        label='Copy link'
                        iconName='copy-link-icon'
                        iconSize={16}
                        iconViewBox='0 0 18 18'
                        iconTone='fill'
                        onClick={() => onClickCopyFigmaLink(domNode.children?.[1]?.attribs?.href)}
                      />
                    </Dropdown>
                  </div>
                </div>
              </ActionDiv>
            );
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'img' &&
            !domNode?.attribs?.class?.includes('figma-icon') &&
            !domNode?.attribs?.class?.includes('refresh-icon') &&
            !domNode?.attribs?.class?.includes('figma-preview-image') &&
            !domNode?.attribs?.class?.includes('assignee-avatar') &&
            !domNode?.attribs?.class?.includes('document-embed-icon') &&
            !domNode?.attribs?.class?.includes('close-icon-image') &&
            !domNode?.attribs?.class?.includes('three-dot-icon') &&
            !domNode?.attribs?.class?.includes('task-assignee') &&
            !domNode?.attribs?.class?.includes('task-avatar')
          ) {
            return (
              <RenderImagePreview
                imageUrl={domNode.attribs.src}
                isImage={true}
                ShowImageOptions={true}
                altText={domNode.attribs.alt}
                type={IMAGE_TYPE.IMAGE}
              />
            );
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'img' &&
            domNode?.attribs?.class?.includes('figma-preview-image')
          ) {
            return (
              <RenderImagePreview
                imageUrl={domNode.attribs.src}
                altText={domNode.attribs.alt}
                type={IMAGE_TYPE.FIGMA}
              />
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('screen-recording-custom-main-div')) {
            const regex = /^<div[^>]*\bclass=["'][^"']*\bscreen-recording-custom-main-div\b[^"']*["']/;
            const matches = regex.test(htmlString.trim());
            return (
              <RenderVideoFile
                videoUrl={domNode?.attribs?.url}
                videoName={domNode?.attribs?.name}
                videoId={domNode?.attribs?.id}
                isStartFromVideo={isReplyText && matches}
              />
            );
          } else if (domNode.type === 'tag' && domNode?.attribs?.class?.includes('prnt-preview-main-div')) {
            return renderPrntImageFile(domNode?.attribs?.url, domNode?.attribs?.name);
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'img' &&
            domNode?.attribs?.class?.includes('figma-icon')
          ) {
            domNode.attribs.src =
              // eslint-disable-next-line max-len
              'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FIcons%3DFill%2C%20Type%3DFile%2C%20Icon%20Name%3DFigma.png?alt=media&token=182ec435-8705-4131-9e42-f76e01d8cfea';
            return domNode;
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'img' &&
            domNode?.attribs?.class?.includes('refresh-icon')
          ) {
            domNode.attribs.src =
              // eslint-disable-next-line max-len
              'https://firebasestorage.googleapis.com/v0/b/teamcamp-app.appspot.com/o/MediaIcons%2FIcons.png?alt=media&token=f85c6305-cb8d-4202-bf35-5bd8f2951758';
            return domNode;
          } else if (domNode.type === 'tag' && domNode.attribs?.class?.includes('youtube-preview-main-div')) {
            const regex = /^<div[^>]*\bclass=["'][^"']*\byoutube-preview-main-div\b[^"']*["']/;
            const matches = regex.test(htmlString.trim());
            return (
              <RenderVideoFile
                isYouTubePreview={true}
                videoUrl={domNode?.attribs?.url}
                videoName={domNode?.attribs?.name}
                videoId={domNode?.attribs?.name}
                isStartFromVideo={isReplyText && matches}
              />
            );
          } else if (domNode.type === 'tag' && domNode.name === 'details') {
            const detailsHtml = serializeNode(domNode);
            return <TiptapEditor valueContent={`${detailsHtml}`} isEditable={false} />;
          } else if (domNode.type === 'tag' && domNode.name === 'pre' && domNode.children?.[0]?.name === 'code') {
            const codeContent = domNode.children[0].children.map((child: CodeChildNode) => child.data).join('');
            const escapedContent = escape(codeContent);
            return <TiptapEditor valueContent={`<pre><code>${escapedContent}</code></pre>`} isEditable={false} />;
          } else if (domNode.type === 'tag' && domNode.name === 'table') {
            return <div className='tableWrapper'>{domToReact([domNode])}</div>;
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'div' &&
            domNode?.attribs?.class?.includes('project-link-embed-preview-main-div')
          ) {
            return <ProjectEmbedCard node={domNode} />;
          } else if (
            domNode.type === 'tag' &&
            domNode.name === 'div' &&
            domNode?.attribs?.class?.includes('task-link-preview-main-div')
          ) {
            return <TaskLinkEmbedCard node={domNode} />;
          } else if (domNode.type === 'tag' && domNode.name === 'a' && domNode.attribs?.href) {
            const isInternal = isSameDomain(domNode.attribs.href);
            return (
              <a
                href={domNode.attribs.href}
                target={isInternal ? undefined : '_blank'}
                rel={isInternal ? undefined : 'noopener noreferrer'}
                onClick={(e) => handleLinkClick(e, domNode.attribs.href)}>
                {domToReact(domNode.children)}
              </a>
            );
          }
          return domNode;
        }
      })}
    </>
  );
}

export default RenderHtml;
